import type { MedplumClient } from "@medplum/core";

/**
 * Ensures the user has a valid, non-expired Medplum session.
 *
 * Calls `refreshIfExpired()` to transparently refresh the token if it's
 * expired or within the grace period (default 5 minutes). If refresh
 * fails or no token exists, throws with a user-facing error.
 *
 * @returns A valid access token string
 * @throws Error if the session cannot be restored
 * @agentic connections
 */
export const ensureActiveSession = async (
  medplum: MedplumClient,
): Promise<string> => {
  // Attempt to refresh the token if it's expired or close to expiring.
  // This is a no-op if the token is still fresh.
  try {
    await medplum.refreshIfExpired();
  } catch {
    throw new Error("Session expired. Please log in again.");
  }

  const accessToken = medplum.getAccessToken();
  if (!accessToken) {
    throw new Error("Not authenticated. Please log in.");
  }

  return accessToken;
};
